import * as React from "react";
const SvgFiBrandsWordpress = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-wordpress_svg__a)">
      <path d="M12.5.72c1.586 0 3.125.298 4.573.886 2.782 1.13 5.077 3.333 6.253 6.003.614 1.391.924 2.868.924 4.391s-.31 3-.923 4.39c-1.162 2.639-3.49 4.881-6.253 6.003a12.1 12.1 0 0 1-4.574.887c-1.586 0-3.125-.298-4.573-.886-2.748-1.116-5.084-3.351-6.253-6.003A10.8 10.8 0 0 1 .75 12c0-1.523.31-3 .923-4.39C2.85 4.939 5.146 2.735 7.927 1.606A12.1 12.1 0 0 1 12.5.72m0-.72C5.597 0 0 5.373 0 12s5.597 12 12.5 12S25 18.627 25 12 19.403 0 12.5 0" />
      <path d="M2.083 12c0 3.958 2.396 7.379 5.871 9L2.985 7.93A9.6 9.6 0 0 0 2.083 12m17.45-.505c0-1.236-.463-2.092-.86-2.758-.527-.824-1.022-1.521-1.022-2.345 0-.919.726-1.775 1.749-1.775q.069.002.134.008C17.681 2.995 15.211 2 12.5 2 8.86 2 5.66 3.793 3.797 6.507c.245.008.475.012.67.012 1.09 0 2.776-.127 2.776-.127.561-.032.627.76.066.824 0 0-.564.063-1.191.095L9.91 18.143l2.28-6.563-1.622-4.269c-.56-.031-1.093-.095-1.093-.095-.562-.032-.495-.855.067-.824 0 0 1.72.127 2.743.127 1.09 0 2.777-.127 2.777-.127.562-.032.628.76.067.824 0 0-.564.063-1.192.095l3.765 10.749 1.075-3.269c.475-1.428.755-2.44.755-3.296m-6.85 1.379-3.126 8.718c.934.264 1.92.408 2.943.408 1.212 0 2.377-.201 3.46-.567a1 1 0 0 1-.076-.138zm8.958-5.672c.044.318.07.66.07 1.028 0 1.014-.199 2.155-.793 3.582l-3.182 8.831c3.098-1.733 5.18-4.954 5.18-8.643a9.64 9.64 0 0 0-1.276-4.798" />
    </g>
    <defs>
      <clipPath id="fi-brands-wordpress_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsWordpress;
